import '@popperjs/core/dist/umd/popper.js'
import 'bootstrap/dist/js/bootstrap.js'
import '@hotwired/turbo-rails' // Turbo

import '../controllers' // Stimulus controllers
